export default "__VITE_ASSET__1e8ad236__"